import FabricOrderType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: FabricOrderType.GET_FABRIC_ORDER_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: FabricOrderType.GET_FABRIC_ORDER_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: FabricOrderType.GET_DETAIL_FABRIC_ORDER_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: FabricOrderType.GET_DETAIL_FABRIC_ORDER_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: FabricOrderType.POST_FABRIC_ORDER,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: FabricOrderType.POST_FABRIC_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: FabricOrderType.PUT_FABRIC_ORDER,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: FabricOrderType.PUT_FABRIC_ORDER_SUCCESS,
  payload: data,
})


// function that called as action
const getList = data => ({
  type: FabricOrderType.GET_FABRIC_ORDER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: FabricOrderType.GET_FABRIC_ORDER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getListNumber = data => ({
  type: FabricOrderType.GET_FABRIC_NUMBER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListNumberSuccess = data => ({
  type: FabricOrderType.GET_FABRIC_NUMBER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getListCustomer = data => ({
  type: FabricOrderType.GET_FABRIC_CUSTOMER_NAME_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListCustomerSuccess = data => ({
  type: FabricOrderType.GET_FABRIC_CUSTOMER_NAME_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getListBunch = data => ({
  type: FabricOrderType.GET_FABRIC_BUNCH_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListBunchSuccess = data => ({
  type: FabricOrderType.GET_FABRIC_BUNCH_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getListBrand = data => ({
  type: FabricOrderType.GET_FABRIC_BRAND_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListBrandSuccess = data => ({
  type: FabricOrderType.GET_FABRIC_BRAND_LIST_SUCCESS,
  payload: data,
})



const FabricOrderAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,


  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

  getList,
  getListSuccess,

  getListNumber,
  getListNumberSuccess,

  getListCustomer,
  getListCustomerSuccess,

  getListBunch,
  getListBunchSuccess,

  getListBrand,
  getListBrandSuccess,


}

export default FabricOrderAction





